import React from 'react';

const Cookies: React.FC = () => {
  return (
    <div className="w-full overflow-hidden pt-24">
      {/* Cookies Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-[#e8f5f0] via-[#f0faf7] to-[#f8fcfb] py-16 md:py-24 overflow-hidden">
        <div className="w-full px-0">
          <div className="text-center mb-8 px-4 sm:px-6 lg:px-8">
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold tracking-tight mb-6">
              <span className="text-emerald-700">Cookie</span> <span className="text-orange-500">Policy</span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-slate-700 leading-relaxed max-w-3xl mx-auto">
              Learn how we use cookies to improve your experience
            </p>
          </div>

          <div className="w-full">
            <img
              src="/images/Privacy and legal.png"
              alt="Cookie Policy"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* Cookies Content Section */}
      <section className="relative w-full bg-[#e8f5f0] py-20 md:py-32 overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-orange-500 mb-4">Cookies Policy</h2>
            <p className="text-slate-600 mb-8 font-semibold">Last updated: April 2026</p>

            <p className="text-slate-700 mb-8">
              At MarketMate, we use cookies and similar technologies to improve your experience and make our platform work smoothly.
            </p>
            <p className="text-slate-700 mb-8">
              This page explains what cookies are, how we use them, and how you can control them.
            </p>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">1. What Are Cookies?</h3>
            <p className="text-slate-700 mb-4">
              Cookies are small text files stored on your device when you visit a website or use an app.
            </p>
            <p className="text-slate-700 mb-8">
              They help us remember your preferences, understand how you use MarketMate, and improve your experience.
            </p>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">2. How We Use Cookies</h3>
            <p className="text-slate-700 mb-4">We use cookies to:</p>
            <ul className="list-disc list-inside text-slate-700 mb-8 space-y-2">
              <li>Keep you logged in to your account</li>
              <li>Remember your preferences and settings</li>
              <li>Understand how users interact with our platform</li>
              <li>Improve performance and fix issues</li>
              <li>Support security and prevent fraud</li>
            </ul>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">3. Types of Cookies We Use</h3>

            <h4 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Essential Cookies</h4>
            <p className="text-slate-700 mb-6">
              These are required for the platform to function properly. Without them, features like login and checkout won't work.
            </p>

            <h4 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Performance Cookies</h4>
            <p className="text-slate-700 mb-6">
              These help us understand how users interact with MarketMate (e.g., pages visited, time spent).
            </p>

            <h4 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Functional Cookies</h4>
            <p className="text-slate-700 mb-6">
              These remember your preferences, such as location or settings, to improve your experience.
            </p>

            <h4 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Analytics & Tracking Cookies</h4>
            <p className="text-slate-700 mb-8">
              We may use trusted tools to analyse usage and improve our services.
            </p>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">4. Third-Party Cookies</h3>
            <p className="text-slate-700 mb-8">
              Some cookies may be set by third-party services we use (such as analytics or payment providers). These third parties have their own privacy and cookie policies.
            </p>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">5. Managing Cookies</h3>
            <p className="text-slate-700 mb-4">
              You can control or disable cookies through your browser settings.
            </p>
            <p className="text-slate-700 mb-4">Please note:</p>
            <ul className="list-disc list-inside text-slate-700 mb-8 space-y-2">
              <li>Disabling cookies may affect how some features work</li>
              <li>Some parts of MarketMate may not function properly without essential cookies</li>
            </ul>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">6. Updates to This Policy</h3>
            <p className="text-slate-700 mb-8">
              We may update this Cookies Policy from time to time. Any changes will be reflected on this page with an updated date.
            </p>

            <h3 className="text-2xl font-bold text-emerald-700 mt-8 mb-4">7. Contact Us</h3>
            <p className="text-slate-700 mb-2">If you have any questions about how we use cookies, you can reach us at:</p>
            <p className="text-slate-700 text-lg">
              📧 <a href="mailto:support@marketmateconnectltd.com" className="text-emerald-600 hover:text-emerald-700 font-semibold">support@marketmateconnectltd.com</a><br />
              📞 <a href="https://wa.me/2348112560962" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 font-semibold">+234 811 256 0962</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
